import { Component, OnInit, Input, TemplateRef, ChangeDetectionStrategy, EventEmitter, Output } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CardConfiguration } from 'app/core/components/workflow-new/course/configurations/card-configuration';

@Component({
  selector: 'itpx-banner-card',
  templateUrl: './banner-card.component.html',
  styleUrls: ['./banner-card.component.css', '../style.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerCardComponent implements OnInit {
  @Input() conf: CardConfiguration;
  @Input() platformClass: any;
  @Input() completedCounter: any;
  @Output() clicked: EventEmitter<any> = new EventEmitter<any>();
  private tagType: string;
  private classType: string;
  private target: string[];
  private instructors: string[];
  private location: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    Object.assign(this, this.conf);
    const sourceVenue = this.platformClass.type === 'class' ? this.platformClass.venue :
      this.platformClass.type === 'exam' && this.platformClass.exam
        && this.platformClass.exam.length > 0 && this.platformClass.exam[0].exam ?
        this.platformClass.exam[0].exam.address : null;
    this.completedCounter = this.platformClass.completedDeliverableCounter;
    let location = sourceVenue ? [sourceVenue.address, sourceVenue.city, sourceVenue.country].filter(v => v) : [];
    if (sourceVenue && sourceVenue.room)
      location.push(`Room ${sourceVenue.room} `);
    this.instructors = this.platformClass.instructors ? Object.keys(this.platformClass.instructors)
      .map(key => this.platformClass.instructors[key].instructor)
      .map(instructor => `${instructor.firstName} ${instructor.lastName}`) : [];
    this.location = this.platformClass.virtualVenue ? 'branded.portal.virtual.class.location' : location.join(', ');
  }

  /*
   * class identifier 'link' is defined in inner-course-card.component.html
   * we also check one level up in DOM hierarchy in case the user clicks on the image of the anchor
   */
  onClick(event: any) {
    if (!event.target.classList.contains('link') && !event.target.parentElement.classList.contains('link')) {
      if (this.conf.clickable)
        this.router.navigate(this.target, { relativeTo: this.route });
    }
  }

  onClicked(event$: any) {
    this.clicked.emit(event$);
  }

  getLocation(venue: any): string {
    return [venue.address, venue.city, venue.country].filter(v => v).join(', ');
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/common/banner-card/banner-card.component.ts